import { Api, ArrayUtil, ExternalLink } from "@mcleod/core";

export class ELearningPortalHomePageLink extends ExternalLink {
    constructor() {
        super("eLearning Portal", null);
    }

    protected override async resolveURL(): Promise<void> {
        const response = await Api.post("helplink/create-url", {});
        const data = ArrayUtil.getFirstElement(response?.data);
        this.url = data?.url;
    }
}
